import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";

interface Props extends InternalIconProps {
  direction: "left" | "right";
}

const AppArrowIcon = (props: Props) => {
  const { className, ...rest } = props;

  if (props.direction === "right") {
    return <IconArrowRight {...rest} className={props.className} />;
  }

  return <IconArrowLeft {...rest} className={props.className} />;
};
export default withIconSize(AppArrowIcon);
